'use client';

import type { ReactNode } from 'react';
import { isValidRichText } from '../_lib/isValidRichText';
import { ScrollPrompt } from '../ScrollPrompt';
import { Media } from '../Media';
import type { SanityImage } from '../types';
import { Text } from '../Text';
import { cn } from '../_lib/utils';

export type HomeHeroProps = {
	className?: string;
	title: ReactNode;
	scrollPrompt?: ReactNode;
	image?: SanityImage;
};

export function HomeHero(props: HomeHeroProps) {
	return (
		<>
			<article data-component='HomeHero' className={cn('relative', props.className)}>
				<div className='relative pt-10 md:py-0 flex flex-col items-center md:grid md:grid-rows-[auto_1fr] md:pt-[clamp(0rem,-8.333rem+14.815vh,5rem)] md:max-h-[66rem] md:h-[calc(100dvh-7.5rem)] lg:h-[calc(100dvh-10rem)]'>
					{isValidRichText(props.title) && (
						<div className={`container-lg max-md:mb-10`}>
							<Text as='h1' className={'relative max-w-[50rem] text-center z-1'} styleType='heading-3xl'>
								{props.title}
							</Text>
						</div>
					)}
					<div className='pointer-events-none relative z-10 top-0 left-0 w-full h-full aspect-2/1 md:aspect-auto'>
						<Media
							image={props.image}
							className='absolute top-0 left-0 h-full w-full [&_img]:h-full! [&_img]:object-contain! [&_img]:scale-[1.6] md:[&_img]:scale-150 md:[&_img]:origin-[50%_25%]'
						/>
					</div>
				</div>

				<div
					className={`pointer-events-none absolute top-0 right-0 w-screen bg-no-repeat bg-cover after:content-[""] after:absolute after:bottom-0 after:left-0 after:w-screen after:h-32 after:bg-linear-to-b after:from-background-primary/0 after:to-background-primary max-md:-top-[7rem] max-md:aspect-375/760 max-md:bg-home-page-bg-mobile md:-top-[10rem] md:aspect-1440/1987 md:bg-home-page-bg-desktop`}
				/>
			</article>
			<ScrollPrompt className='hidden md:block md:z-10'>{props.scrollPrompt}</ScrollPrompt>
		</>
	);
}
